import { FormApi } from '../../../api/FormApi';
import { ControllerFlowAPI, Experiments } from '@wix/yoshi-flow-editor';
import { EmptyStateErrorType } from '../../../types/errors';
import { createDummyState } from '../../dummies/dummy-data';
import { isCartEnabled } from '../utils/utils';
import { IFlowApiAdapter } from '../../flow-api-adapter/types';
import { BusinessInfo } from '../../../types/types';

export async function getDummyData(
  formApi: FormApi,
  wixSdkAdapter: IFlowApiAdapter,
  flowApi: ControllerFlowAPI,
  experiments: Experiments,
) {
  const dummyBusinessInfo: BusinessInfo = {
    regionalSettingsLocale: 'en',
    dateRegionalSettingsLocale: 'en-US',
    isSMSReminderEnabled: false,
    countryCode: 'US',
    name: 'Dummy Business',
    language: 'en',
    currency: 'USD',
    timeZone: 'America/New_York',
    isMultiServicesAppointmentsEnable: false,
  };
  const [
    catalogData,
    isPricingPlanInstalled,
    isMemberAreaInstalled,
    isUpsellPluginInstalled,
  ] = await Promise.all([
    wixSdkAdapter.isSSR()
      ? Promise.resolve({ businessInfo: dummyBusinessInfo })
      : formApi.getCatalogData(),
    wixSdkAdapter.isPricingPlanInstalled().catch(() => false),
    formApi.isMembersAreaInstalled(),
    formApi.isUpsellPluginInstalled(),
  ]);

  if (!catalogData) {
    throw EmptyStateErrorType.INVALID_CATALOG_DATA;
  }

  const isSMSAutomationsEnabled = await formApi.isSMSAutomationsEnabled({
    businessInfo: catalogData.businessInfo,
  });

  const isMultiServicesAppointmentsEnable =
    catalogData.businessInfo.isMultiServicesAppointmentsEnable;

  return createDummyState({
    flowApi,
    businessInfo: catalogData.businessInfo,
    isMemberAreaInstalled,
    isPricingPlanInstalled,
    isMultiServicesAppointmentsEnable,
    isUpsellPluginInstalled,
    isSMSAutomationsEnabled,
    isCart: await isCartEnabled({
      experiments: flowApi.experiments,
      wixSdkAdapter,
      businessInfo: catalogData!.businessInfo,
    }),
    experiments,
  });
}
